import React from "react";

import { SignalWizardStep } from "../../SignalWizard.types";
import CreateTrackerStep from "../../Steps/CreateTrackerStep";
import DestinationsStep from "../../Steps/DestinationsStep";
import SourcesStep from "../../Steps/SourcesStep";
import SuccessStep from "../../Steps/SuccessStep";

const StepManager = ({ step, ...stepProps }) => {
    switch (step) {
        case SignalWizardStep.SOURCES:
            return <SourcesStep {...stepProps} />;
        case SignalWizardStep.DESTINATIONS:
            return <DestinationsStep {...stepProps} />;
        case SignalWizardStep.CREATE_TRACKER:
            return <CreateTrackerStep {...stepProps} />;
        case SignalWizardStep.SUCCESS:
            return <SuccessStep {...stepProps} />;
        default:
            return null;
    }
};

export default StepManager;
